function connectMegaMenu() {
  var sources = document.querySelectorAll('.connect-mega[data-class]');

  sources.forEach(function (sourceMega) {
    var connectClass = sourceMega.getAttribute('data-class');
    var layout = sourceMega.getAttribute('data-layout') || 'classic';

    var targetMega = document.querySelector(
      '.mega-menu[data-class="' + connectClass + '"] .mega-wrapper'
    );

    if (!targetMega) return;

    var children = Array.from(sourceMega.children);
    if (!children.length) return;

    targetMega.innerHTML = '';
    targetMega.setAttribute('data-layout', layout);
    targetMega.classList.remove('mega-wrapper--classic', 'mega-wrapper--editorial');
    targetMega.classList.add('mega-wrapper--' + layout);
    children.forEach(function (child) {
      targetMega.appendChild(child);
    });
    sourceMega.remove();
  });
}

function init() {
  connectMegaMenu();
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:select', init);
